import { Component, Input } from '@angular/core';
import { ICareTeam } from 'src/app/interfaces/CareTeam/ICareTeam';

@Component({
  selector: 'app-care-team-expand',
  templateUrl: './care-team-expand.component.html',
  styleUrls: ['./care-team-expand.component.css'],
  standalone: false,
})
export class CareTeamExpandComponent {
  @Input() item: Partial<ICareTeam> = { participants: [] };
}
